import Vue from 'vue'
import moment from 'moment'

moment.locale('id')

Vue.filter('date', function(value) {
  if (!value) return ''
  value = value.toString()
  return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
})

Vue.filter('dateTime', function(value) {
  if (!value) return ''
  value = value.toString()
  return moment(value).format('DD/MM/YYYY HH:mm')
})

Vue.filter('dateToString', function(value) {
  if (!value) return ''
  return moment(value).format('DD/MM/YYYY')
})
